/**
 * Labstep
 *
 * @module components/Chemical/Form/ShowEdit/MolarAmount
 * @desc ShowEditMolarAmount for Chemical
 */

import { fieldMolarAmount } from 'labstep-web/components/Chemical/Form/fields';
import { FormShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Chemical } from 'labstep-web/models/chemical.model';
import type React from 'react';
import type { ChemicalFormShowEditMolarAmountProps } from './types';

export const ChemicalFormShowEditMolarAmount: React.FC<
  ChemicalFormShowEditMolarAmountProps
> = ({ chemical }) => (
  <FormShowEditText
    entityName={Chemical.entityName}
    entity={chemical}
    field={fieldMolarAmount}
    placeholder="Enter"
    disabled={!chemical.canChangeAmount}
  >
    {chemical.molar_amount}
  </FormShowEditText>
);
